import React, { useState, useEffect } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
} from "react-pro-sidebar";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { BiHomeCircle } from "react-icons/bi";
import { NavLink, useLocation } from "react-router-dom";
import { LuUsers } from "react-icons/lu";
import { MdOutlineCategory, MdOutlineShoppingCart } from "react-icons/md";
import { RiLuggageCartLine } from "react-icons/ri";
import classes from "../style.module.css";
import { Container } from "reactstrap";
import { TbBrandBlogger, TbDeviceDesktopAnalytics } from "react-icons/tb";
import { GiKnightBanner } from "react-icons/gi";
import SiteLogo from "../../../assets/site_logo.png";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { SiPayloadcms } from "react-icons/si";
import { IoMdNotificationsOutline } from "react-icons/io";
import { getServices } from "../../../../apiServices/apiServices";

function Sidebar({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) {
  const [unreadCount, setUnreadCount] = useState(0);
  const location = useLocation();
  const access_token = sessionStorage.getItem("access-token");

  useEffect(() => {
    fetchUnreadCount();
  }, [location.pathname]); // ✅ refresh on every route change

  const fetchUnreadCount = async () => {
    const res = await getServices(
      `/api/notifications/admin-order-notifications`,
      access_token,
    );
    if (res?.responseData) {
      // ✅ Count directly from DB is_read field
      const unread = res.responseData.filter((order) => !order.is_read).length;
      setUnreadCount(unread);
    }
  };

  const sidebarMenu = [
    { title: "Dashboard", icon: <BiHomeCircle />, link: "/admin/dashboard" },
    { title: "Users", icon: <LuUsers />, link: "/admin/users" },
    { title: "Products", icon: <RiLuggageCartLine />, link: "/admin/products" },
    { title: "Orders", icon: <MdOutlineShoppingCart />, link: "/admin/orders" },
    {
      title: "Orders Notification",
      icon: (
        <div style={{ position: "relative", display: "inline-flex" }}>
          <IoMdNotificationsOutline />
          {unreadCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-6px",
                right: "-6px",
                backgroundColor: "#ef4444",
                color: "#fff",
                fontSize: "9px",
                fontWeight: "bold",
                minWidth: "16px",
                height: "16px",
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 3px",
              }}
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </div>
      ),
      link: "/admin/trackorders",
      // badge: unreadCount,
    },
    {
      title: "Manage Category",
      icon: <MdOutlineCategory />,
      link: "/admin/manage_category",
    },
    {
      title: "Manage GST Slab",
      icon: <HiOutlineReceiptTax />,
      link: "/admin/manage_gst",
    },
    {
      title: "Manage Banner",
      icon: <GiKnightBanner />,
      link: "/admin/manage_banner",
    },
    {
      title: "Manage Insights",
      icon: <TbBrandBlogger />,
      link: "/admin/manage_insights",
    },
    { title: "Manage CMS", icon: <SiPayloadcms />, link: "/admin/manage_cms" },
    {
      title: "User Analytics",
      icon: <TbDeviceDesktopAnalytics />,
      link: "/admin/user_analytics",
    },
  ];

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      onToggle={handleToggleSidebar}
      breakPoint="lg"
      className={classes.scrollBarStyle}
    >
      <SidebarHeader>
        <Menu iconShape="circle">
          {collapsed ? (
            <MenuItem
              icon={<FaAngleDoubleRight />}
              onClick={handleCollapsedChange}
            />
          ) : (
            <MenuItem
              suffix={<FaAngleDoubleLeft />}
              onClick={handleCollapsedChange}
            >
              <Container
                style={{
                  fontWeight: "bold",
                  fontSize: 15,
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                <img
                  src={SiteLogo}
                  alt="Site logo"
                  width={"100%"}
                  className="h-20"
                />
              </Container>
            </MenuItem>
          )}
        </Menu>
      </SidebarHeader>

      <SidebarContent>
        <Menu iconShape="circle">
          {sidebarMenu.map((item, i) => (
            <MenuItem
              key={i}
              icon={item.icon}
              className={
                location.pathname === item.link ? "bg-[#ffe1a1] text-black" : ""
              }
              onClick={() => handleToggleSidebar(false, i)}
            >
              <div className="flex items-center justify-between w-full">
                <span>{item.title}</span>
                {/* ✅ Badge count beside title */}
                {item.badge > 0 && (
                  <span
                    style={{
                      backgroundColor: "#ef4444",
                      color: "#fff",
                      fontSize: "10px",
                      fontWeight: "bold",
                      minWidth: "18px",
                      height: "18px",
                      borderRadius: "999px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 4px",
                      marginLeft: "8px",
                    }}
                  >
                    {item.badge > 99 ? "99+" : item.badge}
                  </span>
                )}
              </div>
              <NavLink to={item.link} />
            </MenuItem>
          ))}
        </Menu>
      </SidebarContent>
    </ProSidebar>
  );
}

export default Sidebar;
